import { useExperimentFlag } from './useExperimentFlag';

export const useIsAdvertisingProductsCatalogEnabled = () =>
    Number(useExperimentFlag('advertising_catalog_products_enabled')) === 1;
